// Complete updated AudioManager.js
import backgroundMusic from '../assets/audio/background-music.mp3';
import cardPlay from '../assets/audio/card-play.m4a';
import cardDiscard from '../assets/audio/card-discard.m4a';

class AudioManager {
  constructor() {
	this.backgroundMusic = new Audio(backgroundMusic);
	this.cardPlaySound = new Audio(cardPlay);
	this.cardDiscardSound = new Audio(cardDiscard);

	// Set up background music
	this.backgroundMusic.loop = true;

	// Load saved settings or use defaults
	this.settings = JSON.parse(localStorage.getItem('audioSettings')) || {
	  musicEnabled: true,
	  soundEnabled: true,
	  musicVolume: 0.5,
	  soundVolume: 0.7
	};

	this.isAppActive = true;
	this.applySettings();
  }

  applySettings() {
	// Apply music settings
	this.backgroundMusic.volume = this.settings.musicVolume;
	
	// Handle music state
	if (!this.settings.musicEnabled || !this.isAppActive) {
	  this.pauseBackgroundMusic();
	} else if (this.settings.musicEnabled && this.isAppActive) {
	  this.playBackgroundMusic();
	}

	// Apply sound effect volumes
	this.cardPlaySound.volume = this.settings.soundVolume;
	this.cardDiscardSound.volume = this.settings.soundVolume;

	// Save settings
	localStorage.setItem('audioSettings', JSON.stringify(this.settings));
  }

  playBackgroundMusic() {
	if (this.settings.musicEnabled && this.isAppActive) {
	  const playPromise = this.backgroundMusic.play();
	  if (playPromise !== undefined) {
		playPromise.catch(error => {
		  console.log("Playback prevented:", error);
		});
	  }
	}
  }

  pauseBackgroundMusic() {
	this.backgroundMusic.pause();
  }

  playCardSound() {
	if (this.settings.soundEnabled) {
	  this.cardPlaySound.currentTime = 0;
	  const playPromise = this.cardPlaySound.play();
	  if (playPromise !== undefined) {
		playPromise.catch(error => {
		  console.log("Card sound playback prevented:", error);
		});
	  }
	}
  }

  playDiscardSound() {
	if (this.settings.soundEnabled) {
	  this.cardDiscardSound.currentTime = 0;
	  const playPromise = this.cardDiscardSound.play();
	  if (playPromise !== undefined) {
		playPromise.catch(error => {
		  console.log("Discard sound playback prevented:", error);
		});
	  }
	}
  }

  updateSettings(newSettings) {
	this.settings = { ...this.settings, ...newSettings };
	this.applySettings();
  }

  handleAppState(isActive) {
	this.isAppActive = isActive;
	
	if (!isActive) {
	  // App went to background
	  this.pauseBackgroundMusic();
	} else if (isActive && this.settings.musicEnabled) {
	  // App came to foreground and music is enabled
	  this.playBackgroundMusic();
	}
  }

  // Debug method
  getStatus() {
	return {
	  isAppActive: this.isAppActive,
	  musicEnabled: this.settings.musicEnabled,
	  musicPlaying: !this.backgroundMusic.paused,
	  musicVolume: this.backgroundMusic.volume,
	  soundEnabled: this.settings.soundEnabled,
	  soundVolume: this.settings.soundVolume
	};
  }
}

const audioManager = new AudioManager();
export default audioManager;